import PropTypes from 'prop-types';
import {
  Button, ButtonSizes, ButtonTypes, Tooltip, TooltipPlacements, TooltipThemes,
} from '@leegality/leegality-react-component-library';
import { Icon, IconColors, IconKeys } from '@components/icon';
import { cn } from '@utils/general';
import './help-tooltip.scss';

const TRIGGER_CLASS = 'help-tooltip-trigger';
const POPPER_CLASS = 'help-tooltip-popper';

const stopPropagation = (event) => event.stopPropagation();

/**
 * "?" help icon — a borderless library secondary Button — with a library
 * Tooltip. Focusable (keyboard users get the tooltip on focus) and labelled
 * with its own text. Clicks/keys stop at the icon so it can sit inside
 * clickable rows (group headers, cards) without toggling them.
 */
const HelpTooltip = ({
  text, iconSize, iconColor, placement, className,
}) => (
  // The caller's className (spacing / alignment) sits on a wrapper, so the
  // button keeps its own bare-icon reset (help-tooltip.scss).
  <span className={cn('inline-flex', className)}>
    <Tooltip
      description={text}
      theme={TooltipThemes.DARK}
      placement={placement}
      className={POPPER_CLASS}
    >
      <Button
        type={ButtonTypes.SECONDARY}
        size={ButtonSizes.XXX_SMALL}
        borderLess
        ariaLabel={text}
        className={TRIGGER_CLASS}
        renderIcon={() => <Icon iconName={IconKeys.HelpCircle} size={iconSize} color={iconColor} />}
        onClick={stopPropagation}
        onKeyDown={stopPropagation}
      />
    </Tooltip>
  </span>
);

HelpTooltip.propTypes = {
  text: PropTypes.string.isRequired,
  iconSize: PropTypes.number,
  iconColor: PropTypes.string,
  placement: PropTypes.oneOf(Object.values(TooltipPlacements)),
  className: PropTypes.string,
};

HelpTooltip.defaultProps = {
  iconSize: 14,
  iconColor: IconColors.GRAY,
  placement: TooltipPlacements.TOP,
  className: '',
};

export default HelpTooltip;
